import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ExtendedTransaction, ExtendedTransactionListResponse, TransactionQueryParams } from '@frontend/transaction/types';

export class TransactionExtendedClient extends APIClient {
    public static readonly endpoint = '/transaction-api/ext/v1';

    public static async fetchExtendedTransactions(queryParams?: ApiQueryParams<TransactionQueryParams>): Promise<ExtendedTransactionListResponse> {
        return await this.apiPaginated<ExtendedTransactionListResponse, TransactionQueryParams>(`${this.endpoint}/transactions`, queryParams);
    }

    
    public static async fetchExtendedTransaction(accountId: string, transactionId: string): Promise<ExtendedTransaction> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}`);
        return await this.handleResponse<ExtendedTransaction>(response);
    }
}
